import React, {Component} from 'react'
import PropTypes from 'prop-types'
import Marketplace from './data/Marketplace'
import OrderDesign from './data/OrderDesign'
import ItemType from './data/ItemType'
import ItemQuantity from './data/ItemQuantity'
import ItemStatus from './data/ItemStatus'
import ItemImage from './data/ItemImage'
import ItemNote from './data/ItemNote'
import UploadTime from './data/UploadTime'
import OrderActions from './data/OrderActions'
import {Link} from 'react-router-dom'
import OrderMockUp from './data/OrderMockUp'
import OrderSelection from './data/OrderSelection'
import className from 'classnames'
import ItemSize from './data/ItemSize'
import {message} from 'antd'
import ItemCreated from './data/ItemCreated'
import ItemErrorMessage from './actions/ItemErrorMessage'

class OrderItem extends Component {
    constructor(props) {
        super(props);

        const {order} = this.props
        const itemStatus = order.hasOwnProperty('sub_status') ? order.sub_status : order.production_status
        const {status} = order

        this.state = {
            productionStatus: itemStatus,
            status,
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.isOrdersRefreshed !== this.props.isOrdersRefreshed && this.props.isOrdersRefreshed) {
            const {order} = this.props

            this.setState({
                productionStatus: order.hasOwnProperty('sub_status') ? order.sub_status : order.production_status,
                status: order.status,
            })
        }
    }

    _changePrintState = (value) => {
        this.setState({
            productionStatus: value,
        }, () => {
            let orderState = ''
            const {productionStatus} = this.state

            if ('unprinted' === productionStatus) {
                orderState = 'chưa được in'
            } else if ('printed' === productionStatus) {
                orderState = 'đã được in'
            }

            if (orderState) {
                message.success(`Đơn hàng ${orderState}`)
            }
        })
    }

    _changeStatus = value => {
        this.setState({
            status: value,
        }, () => {
            message.success('Trạng thái đã thay đổi')
        })
    }

    _onUpdateOrdersSelected = (orderId, isAdded) => {
        const {onUpdateOrdersSelected} = this.props

        onUpdateOrdersSelected(orderId, isAdded)
    }

    _warningStyleRow = (item = {}) => {
        if (!Object.keys(item).length) return {}

        const { overtime } = item
        const warningItem = !overtime || overtime > -1.5

        if (!warningItem) return {}

        const overtimed = overtime > 0
        const almostOvertime = overtime >= -1.5 && overtime <= 0

        const background = overtimed
            ? 'rgb(223, 31, 31, 0.2)'
            : almostOvertime
                ? 'rgb(255, 208, 26, 0.3)'
                : ''

        return !!background ? { background } : {}
    }

    render() {
        const {order, selectedOrders, onFetchOrders, checkStatus, itemsRequest, onChangeFilter} = this.props
        const {
            _id,
            marketplace,
            size,
            type,
            quantity,
            image,
            note,
            item_number,
            total_item,
            created_at,
            mark_printed_at,
            preview_image,
            cancelled_reason,
            safezone_image,
            safezone_warning,
            safezone_movable,
            processing_at,
            meta,
            production_file,
        } = order
        const {design_front, design_back, design_sleeves, design_hood, barcode_has_pushed_orders} = order
        const {
            mock_up_front,
            mock_up_back,
            basket_number,
            namespace,
            is_archive,
            batch,
            auto_artwork_approve,
            package_name,
            tags, brand,
            production_tags = [],
        } = order
        const {productionStatus, status} = this.state
        const haveStatus = checkStatus(productionStatus)
        const cancelStatus = checkStatus(status)

        return (
            <tr className={className('OrderItem', {
                'Printed': productionStatus === 'printed',
                'FalseDesign': !!tags && tags.includes('waiting-update-design')
            })} style={this._warningStyleRow(order)}>
                <OrderSelection
                    orderId={_id}
                    selectedOrders={selectedOrders}
                    haveStatus={haveStatus}
                    cancelStatus={cancelStatus}
                    onUpdateOrdersSelected={this._onUpdateOrdersSelected}
                />

                <Marketplace
                    namespace={namespace}
                    basketNumber={basket_number}
                    marketplace={marketplace}
                    itemNumber={item_number}
                    packageName={package_name}
                    totalItems={total_item}
                    size={size}
                    productionStatus={productionStatus}
                    batch={batch}
                    tags={tags}
                />
                <OrderMockUp mockUpFront={mock_up_front} mockUpBack={mock_up_back} orderId={_id}/>
                <OrderDesign
                    designFront={design_front}
                    designBack={design_back}
                    designSleeves={design_sleeves}
                    designHood={design_hood}
                    orderId={_id}
                    tagFalseDesign={!!tags && tags.includes('waiting-update-design')}
                />
                <ItemImage
                    image={image}
                    size={size}
                    previewImage={preview_image}
                    orderId={_id}
                    status={status}
                    type={type}
                    barcode_has_pushed_orders={barcode_has_pushed_orders}
                    haveStatus={haveStatus}
                    cancelStatus={cancelStatus}
                    safezoneImage={safezone_image}
                    safezoneMovable={safezone_movable}
                    onChangeStatus={this._changeStatus}
                    tags={tags}
                    namespace={namespace}
                    muckUpUrl={mock_up_front}
                    meta={meta}
                />
                <ItemType type={type} brand={brand} onChangeFilter={onChangeFilter}/>
                <ItemSize size={size} meta={meta}/>
                <ItemQuantity quantity={quantity}/>
                <ItemStatus
                    orderId={_id}
                    is_archive={is_archive}
                    cancelled_reason={cancelled_reason}
                    status={status}
                    auto_artwork_approve={auto_artwork_approve}
                    tags={tags}
                    safezone_warning={safezone_warning}
                    marketplace={marketplace}
                    itemNumber={item_number}
                    itemsRequest={itemsRequest}
                    processing_at={processing_at}
                    productionTags={production_tags}
                />
                <ItemErrorMessage error={note} safezone_warning={safezone_warning}/>
                <ItemCreated order={order} createdAt={created_at}/>
                <UploadTime uploadedAt={mark_printed_at}/>
                <ItemNote orderId={_id} note={order.message} />

                <td>
                    <OrderActions
                        type={type}
                        tags={tags}
                        brand={brand}
                        namespace={namespace}
                        marketplace={marketplace}
                        itemNumber={item_number}
                        orderId={_id}
                        haveStatus={haveStatus}
                        cancelStatus={cancelStatus}
                        productionStatus={productionStatus}
                        barcode_has_pushed_orders={barcode_has_pushed_orders}
                        status={status} onChangePrintState={this._changePrintState}
                        onChangeStatus={this._changeStatus} onFetchOrders={onFetchOrders}
                    />
                    {(() => {
                        const {barcode_number = '', item_number: pf_item_number = ''} = production_file || {}
                        const mauGocBarcode = barcode_number && pf_item_number
                            ? `${barcode_number}_${pf_item_number}`
                            : null
                        if (!mauGocBarcode) return null
                        return (
                            <div className='MauGoc mt-1'>
                                <Link
                                    to={`/original-file-management?barcode=${encodeURIComponent(mauGocBarcode)}`}
                                    target='_blank'
                                    rel='noopener noreferrer'
                                    style={{ color: '#2a05fa', fontSize: 12, fontWeight: 500 }}
                                >
                                    Màu gốc: #{mauGocBarcode}
                                </Link>
                            </div>
                        )
                    })()}
                </td>
            </tr>
        )
    }
}

OrderItem.propTypes = {
    order: PropTypes.object.isRequired,
    selectedOrders: PropTypes.array.isRequired,
    isOrdersRefreshed: PropTypes.bool.isRequired,
    onUpdateOrdersSelected: PropTypes.func.isRequired,
}

export default OrderItem
